module.exports = {
    RESOURCE_GROUP_ID: 'bcfdd92f-82bc-4fe3-b417-4807862e66dd',
    RESOURCE_GROUP_NAME: 'GRP_EAD_APP_TELEMERCADEO'
}